import { render, staticRenderFns } from "./PollFormWizard.vue?vue&type=template&id=839f4d9c&scoped=true&"
import script from "./PollFormWizard.vue?vue&type=script&lang=js&"
export * from "./PollFormWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f4d9c",
  null
  
)

export default component.exports